import { api, apiAuth } from "../../http";

export const getStoryById = async (id: string): Promise<any> => {
  const response = apiAuth()
    .get(`/stories/${id}`)
    .then(({ data }) => data);
  return response;
};
